import React from 'react'
import openFloatingModal from './openFloatingModal';

function StudentButton({ id, studentProfile, backgroundColor, textColor }) {
  return (
    <button
      key={"button" + id}
      onClick={() => openFloatingModal(id, studentProfile)}
      style={{
        margin: "5px",
        padding: "5px 10px",
        border: `3px solid ${backgroundColor}`,
        borderRadius: "6px",
        minWidth: "50px",
        fontWeight: "bold",
        color: textColor || "#fff",
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.75)", // subtle but visible shadow
        transition: "box-shadow 0.2s ease, transform 0.2s ease",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 10px rgba(0, 0, 0, 0.3)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.2)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {id}
    </button>
  );
}

export default StudentButton;
